var _rect, _rect2, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "component/btn/primary/fav_h"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 14,
    stroke: "#009DA5",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 14,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3244)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colour/secondary/lightCyan+75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 40,
    height: 40,
    fill: "#47D5CD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons/fav/wired"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_3244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9944 32C19.5894 31.6675 19.186 31.3411 18.788 31.0088C16.8833 29.4185 15.0623 27.7394 13.4025 25.8915C12.0315 24.3652 10.7856 22.7463 9.79135 20.9453C9.0582 19.6175 8.49229 18.2258 8.19463 16.7318C7.8616 15.0607 7.94777 13.4152 8.51643 11.8065C9.12108 10.0952 10.295 8.95074 12.0207 8.38051C13.8543 7.7745 15.6401 7.87886 17.3535 8.79072C18.4357 9.36666 19.2222 10.2497 19.8354 11.2973C19.8877 11.3868 19.9387 11.4772 20.0005 11.5849C20.0488 11.5001 20.0881 11.4302 20.1282 11.3606C20.7142 10.3408 21.4694 9.4816 22.4911 8.87581C23.3081 8.39151 24.197 8.12587 25.1375 8.03739C26.589 7.90066 27.9503 8.20969 29.2051 8.94418C30.3559 9.6177 31.0906 10.6381 31.5134 11.8853C32.0429 13.447 32.1328 15.0412 31.8195 16.6603C31.4755 18.4387 30.755 20.0649 29.8271 21.6072C28.7582 23.3839 27.4591 24.9835 26.0455 26.4935C24.1924 28.4728 22.1652 30.2616 20.0536 31.9575C20.0401 31.9685 20.0255 31.9778 19.9944 32Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_3244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/ambient/sophia+75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/ambient/sophia"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7_2",
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#47D5CD"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 10",
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.75
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavH);
export default __webpack_public_path__ + "static/media/fav_h.083958fd750936985606fc29ff504079.svg";
export { ForwardRef as ReactComponent };